import React from 'react';
import { formatPrice } from '../../../../../utils';

export const Item = ({ data, hasNiitaContract }) => {
  const [show, setShow] = React.useState(false);
  const onExpand = () => setShow((arg) => !arg);

  const isIntensiveOnly = data?.isIntensiveRepair && !data?.isNiitaRecommended;

  const tagColorClasses = {
    red: 'bg-red-50 text-red-600 border-red-100',
    blue: 'bg-blue-50 text-blue-600 border-blue-100',
    yellow: 'bg-yellow-50 text-yellow-600 border-yellow-100',
    default: 'bg-slate-100 text-slate-500 border-slate-200',
  };

  return (
    <div
      className={`bg-white rounded-xl overflow-hidden relative ${
        data?.isNiitaRecommended && hasNiitaContract
          ? 'border-2 border-sky-500/20 shadow-[0_1px_10px_0_#006B8833]'
          : isIntensiveOnly
            ? 'border-2 border-red-500/20 shadow-floating'
            : 'border'
      }`}
    >
      {data?.isNiitaRecommended && hasNiitaContract && (
        <div className="absolute top-0 right-0 bg-sky-500 text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg z-10 flex items-center gap-1">
          <span className="material-symbols-outlined !text-[12px]">auto_awesome</span> Niita推奨
        </div>
      )}
      {isIntensiveOnly && (
        <div className="absolute top-0 right-0 bg-red-500 text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg z-10 flex items-center gap-1">
          <span className="material-symbols-outlined !text-[12px]">priority_high</span> 集中修復
        </div>
      )}

      <button onClick={onExpand} className="w-full text-left">
        <div className="p-4 flex items-start gap-4">
          <div className="w-24 h-24 bg-slate-50 rounded-lg flex-shrink-0 flex items-center justify-center border border-slate-100 overflow-hidden">
            {data?.imageUrl ? (
              <img src={data.imageUrl} className="w-full h-full object-cover" alt="" />
            ) : (
              <span className="material-symbols-outlined text-slate-300 text-4xl">soap</span>
            )}
          </div>

          <div className="flex-1 py-1">
            {/* Tags/Series */}
            {data?.tags?.length > 0 && (
              <div className="flex flex-wrap gap-1 mb-1.5">
                {data.tags.map((tag, i) => (
                  <span
                    key={i}
                    className={`text-[9px] px-1.5 py-0.5 rounded border ${
                      tagColorClasses[tag.color] || tagColorClasses.default
                    }`}
                  >
                    {tag.label}
                  </span>
                ))}
              </div>
            )}

            {/* Maker */}
            {data?.maker && <div className="text-[10px] font-bold text-slate-400 mb-0.5">{data.maker}</div>}

            {/* Product Name */}
            <div className="text-sm font-bold text-slate-800 leading-tight mb-2">{data?.name}</div>

            {/* Price */}
            <div className={`text-sm font-bold ${isIntensiveOnly ? 'text-red-500' : 'text-sky-500'}`}>
              ¥{formatPrice(data?.priceTaxInc, false)}{' '}
              <span className="text-[10px] font-normal text-slate-400">(税込)</span>
            </div>
          </div>
        </div>
      </button>

      {/* Description - Show on expand */}
      {show && data?.description && (
        <div
          className={`p-3 border-t ${isIntensiveOnly ? 'bg-red-50 border-red-100' : 'bg-slate-50 border-slate-100'}`}
        >
          <p
            className={`text-xs leading-relaxed bg-white p-2 rounded border break-all whitespace-pre-line ${
              isIntensiveOnly ? 'text-red-700 border-red-200' : 'text-slate-600 border-slate-200'
            }`}
          >
            {data?.description}
          </p>
        </div>
      )}
    </div>
  );
};
